// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-belmont -> aion-management-belmont -> reserves-at-tidewater
// Generated: 2026-10-22T20:05:48.618Z
// Counts: 1 design, 68 content, 59 slot group, 2 collection binding, 9 section, 9 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.pretitle": {
    "overrideType": "VALUE",
    "customValue": "<p>1 - 2 BEDROOM LAYOUTS</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>1 - 2 Bedroom Apartments for Rent in Norfolk , VA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.description": {
    "overrideType": "VALUE",
    "customValue": "<p>At Reserves at Tidewater in Norfolk, VA, vibrant living meets convenience. Nestled amid cultural gems like the Chrysler Museum of Art and breathtaking Norfolk Botanical Garden, our one- and two-bedroom apartments offer easy access to local amenities. Dive into a community teeming with charm, schools, parks, and more!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>tour anytime. from anywhere.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<p>We're Here For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>your new home awaits</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Embrace Comfort and Connection in Your New Apartment Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Accessibility Statement</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Reserves at Tidewater in Norfolk, VA, modern living meets unparalleled comfort. Choose from spacious one or two-bedroom floor plans featuring sleek stainless steel appliances, vaulted ceilings, and private patios. Enjoy our vibrant clubhouse, fitness center, and dog park while experiencing the convenience of flex rent payments and 24-hour maintenance.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Features</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentOverline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Interior</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Amenities</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityOverline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Community</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.select_units_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "*In Select Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Apply Now</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact Us</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Floor Plans</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Spaciously Designed Apartments For Rent</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/patio-balcony-apartments-fullerton-pa::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover ideal apartments with patio or balcony in Fullerton, PA. Enjoy serene outdoor spaces with modern amenities at Fairmont Place.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/patio-balcony-apartments-fullerton-pa::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with Patios &amp; Balconies in Fullerton, PA</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore the community layout</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pet-friendly living guidelines</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Privacy Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Resident Portal</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.app_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Download the Loft Resident Mobile App</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>What residents are saying</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule a Tour</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form_block": {
    "overrideType": "VALUE",
    "customValue": "elise-schedule-tour-iframe",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Sitemap</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Virtual Tours</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Reserves at Tidewater in Norfolk, VA, stylish one and two-bedroom apartments await. Enjoy modern amenities like a fitness center, swimming pool, and dog park, all while relishing the comfort of flexible rent payments and 24-hour maintenance. Your new home is just a click away—lease online today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Reserves at Tidewater in Norfolk, VA, we offer thoughtfully designed one and two-bedroom floor plans to suit your lifestyle. Whether you seek cozy elegance or spacious comfort, our community has the perfect home for you. Have questions? Contact our leasing team today for personalized assistance!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Reserves at Tidewater in Norfolk, VA, elegance meets comfort in every corner. Choose from our thoughtfully designed one and two-bedroom floor plans, crafted to suit your lifestyle. Browse our available apartment homes today and envision your new sanctuary by the water. Your ideal living space awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Reserves at Tidewater in Norfolk, VA, picture picturesque pond views and vaulted ceilings as you relax on your private balcony. Enjoy pet-friendly amenities like a dog park, clubhouse gatherings, and sun-soaked afternoons by the sparkling pool. Each home boasts modern finishes—experience the perfect blend of comfort and community!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Reserves at Tidewater in Norfolk, VA, vibrant living meets convenience. Nestled amid cultural gems like the Chrysler Museum of Art and breathtaking Norfolk Botanical Garden, our one- and two-bedroom apartments offer easy access to local amenities. Dive into a community teeming with charm, schools, parks, and more!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Stylish Apartment Living in Norfolk , VA</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicycallout.description": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 11pt;\">We’re a pet-friendly community and happily welcome cats and dogs. Up to two pets are permitted per apartment. Breed restrictions apply. Please contact the leasing office for details.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our collection of <a href=\"https://www.reservesattidewater.com/floor-plans/\">spacious floor plans</a> and find your perfect landing place in Norfolk at Reserves at Tidewater. Our pet-friendly community provides a comfortable retreat with a host of upgrades plus friendly neighborhood vibes at an affordable price. Here, you can get a workout in or relax in welcoming community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Reserves at Tidewater in vibrant Norfolk, VA, where your ideal living space awaits! Choose from our stylish one or two-bedroom floor plans tailored for comfort. Access your resident portal to seamlessly manage your home—pay rent, schedule maintenance, and enjoy community perks—all at your fingertips!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Reserves at Tidewater in Norfolk, VA, our thoughtfully designed one and two-bedroom floor plans offer the perfect blend of comfort and style. Experience community living where every detail is crafted for you. Curious about your future home? See what our residents have to say about their vibrant lifestyle!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank you for reaching out to Reserves at Tidewater in Norfolk, VA! Our thoughtfully designed one and two-bedroom apartments offer the perfect blend of comfort and style. A member of our dedicated team will connect with you soon to help you find your ideal home sweet home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Step into the vibrant lifestyle at Reserves at Tidewater in Norfolk, VA! With spacious one and two-bedroom floor plans, our community offers the perfect blend of comfort and style. Experience your future home from the comfort of your screen—take a virtual tour of our apartments for rent today!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contact-hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Floor Plans"
      }
    }
  },
  "pinnedcallouts.cta2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Availability & Pricing"
      }
    }
  },
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "amenitieslist.in_home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce07-fba3-744b-b98f-02e795bd3c04.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with a gray sofa, coffee table, plant, and large window with blinds."
      }
    }
  },
  "amenitieslist.indoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-57bd-74fe-8226-0cc1974c37f9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Fitness center with three treadmills and a stationary bike by an orange wall."
      }
    }
  },
  "amenitieslist.indoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026d-b3db-737f-9a5c-b7033071246c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "On-site fitness center with cardio machines and a wall-mounted TV."
      }
    }
  },
  "amenitieslist.indoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026a-c897-76ed-a13f-57308f6e8343.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Clubhouse living room with a blue accent wall, fireplace, wall-mounted TV, and large windows."
      }
    }
  },
  "amenitieslist.indoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026d-af2e-72b7-ad83-856613881b96.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resident lounge with a wall-mounted TV, high-top seating, and a computer workstation."
      }
    }
  },
  "amenitieslist.inHomePhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026d-64d5-75d6-8669-ad653234a434.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment kitchen with white cabinets, stainless steel appliances, and a subway tile backsplash."
      }
    }
  },
  "amenitieslist.inHomePhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026d-7485-746f-a5bd-d43d8fce8f8f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment living room with a sofa, coffee table, area rug, and ceiling fan."
      }
    }
  },
  "amenitieslist.inHomePhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026d-8d86-72aa-8197-19b59e74cc9d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Apartment bedroom with a large bed, dresser, and wall-mounted TV."
      }
    }
  },
  "amenitieslist.neighborhood_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-66ec-7111-945b-eeaf6a158e01.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a brick apartment building with arched windows along a tree-lined street."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-4d68-73fb-b3a3-6ee75b888ce1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Norfolk Botanical Garden, a lush green space near the community with azaleas and roses."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-308e-7627-931c-8751284ec213.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Nauticus, the downtown Norfolk waterfront maritime museum and battleship attraction."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026b-4d7b-714e-89a8-e815fd8573b6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Ocean View Beach Park, a nearby stretch of beach and boardwalk with a music bandshell."
      }
    }
  },
  "amenitieslist.outdoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-4c49-7252-89ac-296366e54629.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor apartment community pool with lounge chairs, clear water, and surrounding trees."
      }
    }
  },
  "amenitieslist.outdoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026d-d3d3-72ea-9023-988491842f8a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor community pool with white lounge chairs bordered by mature trees."
      }
    }
  },
  "amenitieslist.outdoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026d-b06f-73ff-ad04-7c9a08eab9d8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "On-site dog park with agility equipment for residents' pets."
      }
    }
  },
  "amenitieslist.outdoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026d-d94a-758a-8ffd-d5abad60ee7c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Community grilling and picnic area in a landscaped courtyard."
      }
    }
  },
  "feesheet.application": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Application Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Per applicant."
      }
    }
  },
  "feesheet.buyout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Buy-Out Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "1 Month's Rent"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.electric": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Electric"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.late": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Late Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "10%"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.month_to_month": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Month To Month"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.nsf": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "NSF Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.parking_reserved": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Reserved Parking Space"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.parking_unreserved": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Parking - Unreserved"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$25"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.pet_fee": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.pet_fee_2nd": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amount": {
        "type": "VALUE",
        "customValue": "150"
      }
    }
  },
  "feesheet.pet_rent": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$55"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Per pet. Max 2."
      }
    }
  },
  "feesheet.reservation": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Reservation Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$200"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.security": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Security Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$750*"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Deposit amount applies with approved credit and may be higher for conditional approvals"
      }
    }
  },
  "feesheet.transfer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Transfer Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$500"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.utility_setup": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility New Account"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$10"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.washer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Washer/Dryer Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$60"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.water": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Water & Sewer"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "floorplanslist.card_image_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce6d-f09e-7287-b308-950eba49c2e0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "blank transparent image"
      }
    }
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019d026d-7485-746f-a5bd-d43d8fce8f8f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Compact apartment living room with a sofa, coffee table, rug, ceiling fan, and window blinds."
      }
    }
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce6d-f0e3-7427-9309-03f91e14f594.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "blank transparent image"
      }
    }
  },
  "floorplanslist.card_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce6d-f82b-7306-b4e6-7d57fadd5a5f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "blank transparent image"
      }
    }
  },
  "floorplanslist.card_image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166342/019d026a-c897-76ed-a13f-57308f6e8343.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious apartment living room with a sectional sofa, fireplace, TV, and a small dining area."
      }
    }
  },
  "neighborhoodhighlights.day_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-a426-7747-ba0a-e6a54fe3cce2.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Bel Aire Pancake House"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Breakfast & Diner"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "6.2 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Relaxed 1950s and 1960s-style diner in Larrymore Lawns serving up breakfast, as well as lunch and dinner."
      }
    }
  },
  "neighborhoodhighlights.day_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-bf86-7703-9e06-737983b24416.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Harris Teeter"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Shopping & Grocery"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "1.5 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Large supermarket chain with deli & bakery departments, plus health & beauty aids."
      }
    }
  },
  "neighborhoodhighlights.day_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-ee2e-71b8-9ee7-c937f5094c5b.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Norfolk Botanical Garden"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Parks & Gardens"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.4 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "April azaleas are the showstoppers at this lush green space, which also features 450 rose varieties."
      }
    }
  },
  "neighborhoodhighlights.day_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-b2de-71f4-a113-9b5d50502561.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "The Ten Top"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Dining & Brunch"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "4.6 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Storefront American joint dishing out sandwiches, salads & full dinners, with vegetarian options."
      }
    }
  },
  "neighborhoodhighlights.day_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-d8e1-7129-b8b3-02862be30ae9.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Chrysler Museum of Art"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Arts & Culture"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.2 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Esteemed museum with a broad collection of ancient to contemporary art, including glass & sculpture."
      }
    }
  },
  "neighborhoodhighlights.day_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-ed19-772b-91db-8adf056d3986.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Northside Park"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Recreation & Trails"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.1 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "This 62-acre recreation area has a skate park, an indoor pool, picnic shelters & kids' play areas."
      }
    }
  },
  "neighborhoodhighlights.night_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-b7d5-7672-bbbf-989f2ae7276a.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Saltine"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Bar & Cocktails"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.0 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Spacious, brick-clad eatery offering seafood, oysters & fresh produce plus cocktails & beer."
      }
    }
  },
  "neighborhoodhighlights.night_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-d239-716c-ae98-35af401648ab.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "The NorVa"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Live Music"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.6 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Downtown music venue for national indie bands with a general admission floor & a small balcony."
      }
    }
  },
  "neighborhoodhighlights.night_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-b27f-7326-83b5-27e020eb78af.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "El Azteca - Norfolk"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Dinner & Drinks"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "6.1 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "One of a local chain offering Mexican staples & margaritas in cantina quarters with a patio."
      }
    }
  },
  "neighborhoodhighlights.night_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-aae8-72a6-a6a8-3604b66e4430.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Your Pie Pizza"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Pizza & Microbrews"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.8 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Diners choose their dough, sauce, cheese & toppings at this pizzeria chain with gelato & microbrews."
      }
    }
  },
  "neighborhoodhighlights.night_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-d2f0-718e-b131-38d8f9c39f38.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Regal Macarthur Center"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cinema & Theater"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.5 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Theater complex with multiple screens featuring new release films, plush seating & concession stand."
      }
    }
  },
  "neighborhoodhighlights.night_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166342/019fce08-b237-721c-86a1-649389284bdf.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Salmich's Burgers & Hoagies"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Late-Night Eats"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.8 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Casual sandwich spot offering a menu of subs, burgers, and sides, plus beer."
      }
    }
  },
  "neighborhoodshowcase.photo1": {
    "sourceIndex": 29,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo2": {
    "sourceIndex": 28,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo3": {
    "sourceIndex": 20,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo4": {
    "sourceIndex": 25,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "propertyoverview.images": {
    "limit": 3,
    "hiddenIds": null,
    "orderedIds": [
      "custom_9d8c8518-dc32-4dad-a4af-e0e7389307bd",
      "custom_a7051dc4-63fa-4b18-982d-46daa91a81ae",
      "custom_877f7139-5951-4779-abcd-a6cec1270710",
      "custom_1edcfc03-508b-400f-a38f-c5f983b5eb37",
      "custom_c9c0033f-4adb-494f-82a8-faa5f92628b8",
      "custom_4b9166b7-609b-4855-9482-bb681b50dbf0",
      "custom_9d0939a2-a0aa-45a0-8bec-b49be91494de",
      "custom_da47be76-cf59-4c1e-ab72-bfd63a2cbe6b",
      "custom_8bb0a1ab-7c98-446e-870c-20791a34b650",
      "custom_8d164234-8be3-43c4-b1ca-63485351fe73",
      "custom_133316de-1fa7-43d9-87ec-d09438773948",
      "custom_0027a46a-2f51-4078-a1fd-ff6e29fae4ab",
      "custom_15679934-0fa2-4417-a92c-4c8928893b74",
      "custom_e0b86692-de40-4656-9636-13866319da24",
      "custom_b949dd0c-e64d-4d31-b5e1-6f7708fb0389",
      "custom_d1488b0f-03e7-47e1-9d20-16a4e6b49314",
      "custom_66777d26-a436-4a65-a25b-789cac0defa4",
      "custom_d58de066-01fc-4630-a010-72f71d7eaf88"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "galleryapartments.images": {
    "limit": null,
    "hiddenIds": [
      "custom_c2748f5e-c78c-43be-ad11-83922dcfbe44",
      "custom_94521dd0-9b9e-48cf-9227-e362744088fe",
      "custom_15679934-0fa2-4417-a92c-4c8928893b74"
    ],
    "orderedIds": [
      "custom_9d8c8518-dc32-4dad-a4af-e0e7389307bd",
      "custom_4b9166b7-609b-4855-9482-bb681b50dbf0",
      "custom_877f7139-5951-4779-abcd-a6cec1270710",
      "custom_a7051dc4-63fa-4b18-982d-46daa91a81ae",
      "custom_1edcfc03-508b-400f-a38f-c5f983b5eb37",
      "custom_c9c0033f-4adb-494f-82a8-faa5f92628b8",
      "custom_9d0939a2-a0aa-45a0-8bec-b49be91494de",
      "custom_da47be76-cf59-4c1e-ab72-bfd63a2cbe6b",
      "custom_8bb0a1ab-7c98-446e-870c-20791a34b650",
      "custom_8d164234-8be3-43c4-b1ca-63485351fe73",
      "custom_133316de-1fa7-43d9-87ec-d09438773948",
      "custom_0027a46a-2f51-4078-a1fd-ff6e29fae4ab",
      "custom_15679934-0fa2-4417-a92c-4c8928893b74",
      "custom_e0b86692-de40-4656-9636-13866319da24",
      "custom_b949dd0c-e64d-4d31-b5e1-6f7708fb0389",
      "custom_d1488b0f-03e7-47e1-9d20-16a4e6b49314",
      "custom_66777d26-a436-4a65-a25b-789cac0defa4",
      "custom_d58de066-01fc-4630-a010-72f71d7eaf88",
      "custom_9a0c65e2-cf7d-4a8b-8e33-e01b8afc9afe",
      "custom_7c8c8bd5-de45-40fe-ac3a-45123ee7de8f",
      "custom_78106a01-c479-4315-be17-67253566d037",
      "custom_596c35d7-ba13-424b-8e8f-9069a3d69417",
      "custom_94521dd0-9b9e-48cf-9227-e362744088fe",
      "custom_eafdda0f-873d-4bd3-964f-2dd76b1e2eae",
      "custom_c2748f5e-c78c-43be-ad11-83922dcfbe44",
      "custom_fc271def-9c2c-439e-81fd-15751dbb328e",
      "custom_70418186-d684-41c3-852b-92ed69645fb9",
      "custom_0c415861-edf0-409f-bb3e-0ba7fbdb32bc",
      "custom_99232045-93df-429c-b387-90949b4a0b42",
      "custom_c6f31ef9-4718-42ee-b346-65b2f0d0bd1d"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 9
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "_template:hyperlocal::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/air-conditioned-apartments-newport-news-city-harborstone-444::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/dog-park-apartments-newport-news-va-harborstone-222::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/extra-storage-apartments-fullerton-pa-469::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/fitness-center-apartments-23601-harborstone-366::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/pet-friendly-apartments-south-newport-news-harborstone-651::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "_section.InteractiveMapSection": {
    "properties": {
      "paddingTop": "50px",
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "apartmentsyncsection.block": {
    "properties": {
      "paddingTop": "50px",
      "paddingBottom": "50px"
    }
  }
};
